import React from 'react';
import { Skeleton, Progress, Typography, Row, Col, Space, Badge } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { SalesSLAResponsiveness } from '../../../types/dashboard';
import { getProgressColor } from '../utils';

const { Title, Text } = Typography;

interface SalesDetailSlaCardProps {
  sla: SalesSLAResponsiveness | null;
  slaComplianceRate: number | undefined;
  loading: boolean;
  glassCardStyle: React.CSSProperties;
}

const SalesDetailSlaCard: React.FC<SalesDetailSlaCardProps> = ({
  sla,
  slaComplianceRate,
  loading,
  glassCardStyle
}) => {
  return (
    <div className="glass-card-interactive" style={{ ...glassCardStyle, padding: '20px', minHeight: '340px' }}>
      {loading || !sla ? (
        <Skeleton active paragraph={{ rows: 8 }} />
      ) : (
        <div>
          <Title level={5} style={{ color: '#1e293b', fontWeight: 'bold', margin: '0 0 16px 0' }}>
            <ClockCircleOutlined style={{ color: '#1890ff', marginRight: '8px' }} />
            Kedisiplinan Respon & SLA
          </Title>
          <Row gutter={[16, 16]} align="middle">
            <Col xs={12} style={{ textAlign: 'center', borderRight: '1px solid rgba(0,0,0,0.06)' }}>
              <Progress
                type="circle"
                percent={slaComplianceRate ? parseFloat(slaComplianceRate.toFixed(1)) : 0}
                strokeColor={getProgressColor(slaComplianceRate ?? 0)}
                width={110}
                strokeWidth={8}
              />
              <Text strong style={{ display: 'block', marginTop: '12px', color: '#475569', fontSize: '12px' }}>
                Rasio Kepatuhan SLA
              </Text>
            </Col>
            <Col xs={12} style={{ paddingLeft: '24px' }}>
              <Space direction="vertical" size={10}>
                <div>
                  <Text type="secondary" style={{ fontSize: '11px', display: 'block' }}>Rata-rata Waktu Respons</Text>
                  <Text strong style={{ fontSize: '18px', color: '#1e293b' }}>
                    {sla.average_response_time_minutes.toFixed(1)} <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#64748b' }}>Menit</span>
                  </Text>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', borderTop: '1px solid rgba(0,0,0,0.04)', paddingTop: '10px' }}>
                  <Space size={6} style={{ fontSize: '12px' }}>
                    <Badge status="success" />
                    <Text style={{ color: '#475569' }}>Tepat Waktu: <b>{sla.status_distribution.achieved_on_time}</b></Text>
                  </Space>
                  <Space size={6} style={{ fontSize: '12px' }}>
                    <Badge status="warning" />
                    <Text style={{ color: '#475569' }}>Terlambat: <b>{sla.status_distribution.achieved_late}</b></Text>
                  </Space>
                  <Space size={6} style={{ fontSize: '12px' }}>
                    <Badge status="error" />
                    <Text style={{ color: '#475569' }}>Kedaluwarsa (Expired): <b>{sla.status_distribution.expired}</b></Text>
                  </Space>
                </div>
              </Space>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default SalesDetailSlaCard;
